import React, { useState, useEffect } from "react";
import { Breadcrumb, Button, Card, CardBody, CardHeader, Col, Container, Nav, Row, Stack } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import * as constants from "../../constants/CONSTANT";
import Image from "react-bootstrap/Image";
import moment from "moment";
import { disableCursor } from "@fullcalendar/core/internal";
import Permissionhelper from "../common/Permissionhelper";
import { ROUTES } from "../../constants/webRouting";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import PERMISSIONS from "../../constants/permissions";
import { getUserDetails } from "../../utils/helper";

const AccountView = (props) => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [account, setAccount] = useState(location.state ? location.state : {});
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    init();
  }, []);

  async function init() {
    let result = await fuziElevatorsApi.fetchAccountById(
      account.id ? account.id : location?.pathname?.split('/')?.at(2)
    );

    if (result) {
      setAccount(result);
    }
  }

  const deleteAccount = async () => {
    const result = await fuziElevatorsApi.deleteAccounts(account.id);
    if (result.success) navigate(`/accounts`);
  };

  const editAccount = () => {
    navigate(`/accounts/${account.id}/e`, { state: account });
  };

  return (
    <>
      {account && (
        <Container className="pb-5" >
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteAccount={deleteAccount}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="account"
            />
          )}
          <Row className="">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>Home</Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.ACCOUNT.LIST)} >Make</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col md={12}>
              <Row className="">
                <Col lg={12}>
                  <Card className="shadow">
                    <CardHeader className="bg-custom text-white">
                      <Row className="w-100"  >
                        <Col lg={6} className="" >
                          <div className="d-flex align-items-center h-100 gap-3" >
                            <h5 className="m-0">
                              Make
                            </h5>
                            <h5 className="m-0">
                              {`${account.name || ""}`}
                            </h5>
                          </div>
                        </Col>
                        <Col lg={6} className="p-0" >

                          <Stack direction="horizontal" className="float-end" gap={3}>
                            {
                              [PERMISSIONS.MODIFY_ALL, PERMISSIONS.MODIFY_MAKE].some(permission => {
                                return userInfo?.permissions.map(p => p.name).includes(permission);
                              }) &&
                              <Button
                                size="sm"
                                className="btn-edit"
                                onClick={() => editAccount(true)}
                              >
                                <i className="fa-regular fa-pen-to-square"></i>
                              </Button>
                            }

                            {[PERMISSIONS.DELETE_ALL, PERMISSIONS.DELETE_MAKE].some(permission => {
                              return userInfo?.permissions.map(p => p.name).includes(permission);
                            }) && (
                                <Button
                                  size="sm"
                                  className="btn-delete"
                                  onClick={() => setModalShow(true)}
                                >
                                  <i className="fa fa-trash-o"></i>
                                </Button>
                              )}
                          </Stack>

                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody className="">
                      <Row className="view-form">
                        <Col lg={6}>
                          <label>Name</label>
                          <span>
                            {account.name}
                          </span>
                        </Col>
                        {/* Added by imran khan */}
                        <Col lg={6}>
                          <label>Type</label>
                          <span>
                            {account.type}
                          </span>
                        </Col>

                        <Col lg={6}>
                          <label>Website</label>
                          <span>
                            {account.website}
                          </span>
                        </Col>

                        <Col lg={6}>
                          <label>Email</label>
                          <span>{account.email}</span>
                        </Col>

                        <Col lg={6}>
                          <label>Phone</label>
                          <span>{account.phone}</span>
                        </Col>

                        <Col lg={6}>
                          <label>State</label>
                          <span>{account.state}</span>
                        </Col>
                        <Col lg={6}>
                          <label>City</label>
                          <span>
                            {account.city}
                          </span>
                        </Col>
                        <Col lg={6}>
                          <label>Street</label>
                          <span>{account.street}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Pincode</label>
                          <span>{account.pincode}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Country</label>
                          <span>{account.country}</span>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};
export default AccountView;
